'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var styles = {
  widgetContainer: {
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 20px 20px 0',
    position: 'fixed',
    right: 0,
    zIndex: 9999
  },
  fullscreen: {
    height: '100%',
    margin: 0,
    width: '100%'
  }
};

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-chat-popup/lib/components/Chat/style.js
// module id = 1018
// module chunks = 0